import { useEffect, useState, SubmitEvent, SubmitEventHandler } from 'react'
import Link from 'next/link'
import plans from '@/data/plans'
import Label from '@/components/common/Label'
import { className } from '@/components/common/styles'
import { isIterableArray } from '@/lib/helpers'
import Panel from '@/components/common/Panel'

interface Props {
  className?: string
}

const Plan = (props: Props) => {
  const selected = plans.findIndex((plan) => plan.selected)
  const [plan, setPlan] = useState(plans[selected].label)
  useEffect(() => setPlan(plans[selected].label), [selected])

  const handlePlanSettings: SubmitEventHandler = (
    e: SubmitEvent<HTMLInputElement>,
  ) => {
    e.preventDefault()
    console.log({
      plan,
    })
  }

  return (
    <div className={`p-4 ${props.className}`}>
      <Panel title="Plan">
        <form onSubmit={handlePlanSettings}>
          <div className="grid grid-cols-2 gap-x-8">
            <div className="col-span-2">
              <Label
                id="plan"
                label="Plan"
                value={plan}
                type="select"
                populate={
                  isIterableArray(plans) &&
                  plans.map((plan_item, index) => (
                    <option
                      className="bg-white dark:bg-black text-black dark:text-white"
                      value={plan_item.label}
                      disabled={plan_item.disabled ?? false}
                      key={index}
                    >
                      {plan_item.label}
                    </option>
                  ))
                }
                onChange={() => console.log('change')}
              />
              {/*
                      ({ target }) =>
                      setPlan((target as HTMLInputElement).value)
                  */}
            </div>
            <div className="col-span-2 pb-4">
              <Link href="#!">
                <div className="text-blue-600 dark:text-blue-400 hover:underline decoration-2">
                  Read more about our plans and how you can switch to a
                  different plan
                </div>
              </Link>
            </div>
            <div className="col-span-2 pb-4">
              <Link href="#!">
                <div className="text-blue-600 dark:text-blue-400 hover:underline decoration-2">
                  Contact Sales about Enterprise plan
                </div>
              </Link>
            </div>
            <div className="col-span-2 pb-2">
              <button
                className={`${className} float-end`}
                type="submit"
                onClick={() => console.log('click button')}
              >
                {/* {handlePlanSettings} */}
                Switch plan
              </button>
            </div>
          </div>
        </form>
      </Panel>
    </div>
  )
}

export default Plan
